import React from "react";
import { ClassNameMap } from '@mui/styles';
import {
  Box,
  FormControlProps,
  MenuItem, OutlinedInputProps,
  SelectProps, SxProps
} from '@mui/material';
import { TextInput } from './text-input/text-input';
import { CaretUpDown } from '@phosphor-icons/react/dist/ssr/CaretUpDown';

export type SelectInputProps = FormControlProps<'select', SelectProps> & {
  helperText?: string | React.ReactElement,
  placeholder?: string,
  labelClassName?: string,
  paperClassName?: string,
  loading?: boolean,
  hideTick?: boolean,
  valid?: boolean,
  validate?: boolean,
  wrapperSx?: SxProps,
  styles?: ClassNameMap<'paper' | 'root' | 'select' | 'inputLabel'>,
  InputProps?: Partial<OutlinedInputProps | undefined>,
  component?: React.FC<SelectInputProps>,
  tickIcon?: React.ReactNode,
}

// 55385
export function SelectInput(props: SelectInputProps) {
  const {component, helperText, paperClassName, loading, validate, valid, labelClassName, hideTick, InputProps, wrapperSx, tickIcon, ...rest} = props;

  const placeholderClassName = !props.value && props.placeholder ? 'MuiSelect-placeholder' : '';

  const Component: any = component ? component : TextInput;

  return (
      <Component
        fullWidth
        select
        valid={valid}
        wrapperSx={wrapperSx}
        loading={loading}
        validate={validate}
        className={props.className}
        hideTick={hideTick}
        value={props.value}
        label={props.label}
        inputLabelClass={props.labelClassName}
        name={props.name}
        error={props.error}
        helperText={helperText}
        tickPosition={'start'}
        endAdornmentSx={{mr: '27px'}}
        InputProps={InputProps}
        tickIcon={tickIcon}
        SelectProps={{
          IconComponent: Caret,
          ...rest,
          displayEmpty: true,
          className: placeholderClassName,
          MenuProps: {
            ...rest.MenuProps,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'center',
            },
            PopoverClasses: {
              paper: paperClassName,
            },
            BackdropProps: {
              sx: {
                background: 'transparent',
              }
            }
          }
        }}
        placeholder={props.placeholder} >
        {!!props.placeholder && <MenuItem sx={{display: 'none'}} value="" disabled>
          {props.placeholder}
        </MenuItem>}
        {props.children}
      </Component>
  );
}

const Caret = (props: any) => <Box {...props}><CaretUpDown size={24} color="#4B5563" weight="regular" /></Box>

